import { createReducer } from '../../utils/createReducer';
import { BehaviorState } from '../types';

import {
  BehaviorActions,
  CHANGE_BUTTON_START_STATE,
  SET_OPERATOR_PRINTING,
  TOGGLE_CHAT,
  TOGGLE_CONNECTION_AWAIT,
  TOGGLE_INPUT_DISABLED,
  TOGGLE_MESSAGE_LOADER,
} from '../actions/types';


const initialState: BehaviorState = {
  showChat: false,
  disabledInput: false,
  messageLoader: false,
  isShowStartButton: true,
  isConnectionAwaiting:  true,
  isOperatorPrinting: false,
};

const behaviorReducer = {
  [TOGGLE_CHAT]: (state: BehaviorState) => ({ ...state, showChat: !state.showChat }),

  [TOGGLE_INPUT_DISABLED]: (state: BehaviorState) => ({ ...state, disabledInput: !state.disabledInput }),

  [TOGGLE_MESSAGE_LOADER]: (state: BehaviorState) => ({ ...state, messageLoader: !state.messageLoader }),

  [TOGGLE_CONNECTION_AWAIT]: (state: BehaviorState, { status }) =>({ ...state, isConnectionAwaiting: status ?? !state.isConnectionAwaiting }),

  [CHANGE_BUTTON_START_STATE]: (state: BehaviorState, { showStart }) => {
    return { ...state, isShowStartButton: showStart }
  },
  
  [SET_OPERATOR_PRINTING]: (state: BehaviorState, { isPrinting }) => {
    return { ...state, isOperatorPrinting: isPrinting }
  },
};

export default (state: BehaviorState = initialState, action: BehaviorActions) => createReducer(behaviorReducer, state, action);
